var map = {
	"./assets/fonts/fonts": [
		6592,
		9
	],
	"./assets/fonts/fonts.js": [
		6592,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.eot": [
		39362,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.ttf": [
		80673,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.woff": [
		90360,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Medium-WebS.woff2": [
		93829,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.eot": [
		88866,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.ttf": [
		54537,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.woff": [
		97073,
		9
	],
	"./assets/fonts/suisse-int-l/SuisseIntl-Regular-WebS.woff2": [
		63771,
		9
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.eot": [
		18213,
		9,
		826
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.woff": [
		1006,
		9,
		2720
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular-italic.woff2": [
		20210,
		9,
		8768
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.eot": [
		41479,
		9
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.woff": [
		13298,
		9
	],
	"./assets/fonts/tiempos-text/tiempos-text-web-regular.woff2": [
		87748,
		9
	],
	"./assets/icons/bergTextLogo.svg": [
		13016,
		9
	],
	"./assets/icons/burgerIcon.svg": [
		25084,
		9,
		763
	],
	"./assets/icons/mastercard.svg": [
		64885,
		9,
		9351
	],
	"./assets/icons/visa.svg": [
		45038,
		9,
		9351
	],
	"./cache/analysts": [
		48613,
		3,
		1569
	],
	"./cache/analysts.json": [
		48613,
		3,
		1569
	],
	"./cache/categories": [
		65381,
		3,
		8478
	],
	"./cache/categories.json": [
		65381,
		3,
		8478
	],
	"./cache/footer": [
		36493,
		3
	],
	"./cache/footer.json": [
		36493,
		3
	],
	"./cache/header": [
		4230,
		3
	],
	"./cache/header.json": [
		4230,
		3
	],
	"./cache/images": [
		4565,
		3,
		4642
	],
	"./cache/images.json": [
		4565,
		3,
		4642
	],
	"./cache/pages": [
		65554,
		3,
		7329
	],
	"./cache/pages.json": [
		65554,
		3,
		7329
	],
	"./cache/posts": [
		57255,
		3,
		7912
	],
	"./cache/posts.json": [
		57255,
		3,
		7912
	],
	"./cache/productPanels": [
		70004,
		3,
		3038
	],
	"./cache/productPanels.json": [
		70004,
		3,
		3038
	],
	"./cache/products": [
		7628,
		3,
		5308
	],
	"./cache/products.json": [
		7628,
		3,
		5308
	],
	"./cache/sites": [
		41258,
		3,
		8461
	],
	"./cache/sites.json": [
		41258,
		3,
		8461
	],
	"./components/Account/AccountNav": [
		95740,
		9,
		9351
	],
	"./components/Account/AccountNav.js": [
		95740,
		9,
		9351
	],
	"./components/Account/AccountSettings": [
		71364,
		9,
		9351
	],
	"./components/Account/AccountSettings.js": [
		71364,
		9,
		9351
	],
	"./components/Account/AccountSettingsPopup": [
		57642,
		9,
		9351
	],
	"./components/Account/AccountSettingsPopup.js": [
		57642,
		9,
		9351
	],
	"./components/Account/CategoryFilters": [
		93322,
		9,
		9351
	],
	"./components/Account/CategoryFilters.js": [
		93322,
		9,
		9351
	],
	"./components/Account/ChangePassword": [
		23887,
		9,
		9351
	],
	"./components/Account/ChangePassword.js": [
		23887,
		9,
		9351
	],
	"./components/Account/DownloadButton": [
		79626,
		9,
		9351
	],
	"./components/Account/DownloadButton.js": [
		79626,
		9,
		9351
	],
	"./components/Account/MoreInfoPanel": [
		42881,
		9,
		2904,
		9351
	],
	"./components/Account/MoreInfoPanel.js": [
		42881,
		9,
		2904,
		9351
	],
	"./components/Account/MyReports": [
		56501,
		9,
		2904,
		6294,
		9351
	],
	"./components/Account/MyReports.js": [
		56501,
		9,
		2904,
		6294,
		9351
	],
	"./components/Account/ProfileView": [
		16374,
		9,
		9351
	],
	"./components/Account/ProfileView.js": [
		16374,
		9,
		9351
	],
	"./components/Account/ReportCard": [
		68887,
		9,
		9351
	],
	"./components/Account/ReportCard.js": [
		68887,
		9,
		9351
	],
	"./components/Account/ReportHeader": [
		25731,
		7,
		1511
	],
	"./components/Account/ReportHeader.js": [
		25731,
		7,
		1511
	],
	"./components/Account/ReportItem": [
		72282,
		9,
		9351,
		6606
	],
	"./components/Account/ReportItem.js": [
		72282,
		9,
		9351,
		6606
	],
	"./components/Account/ReportSearch": [
		21028,
		9,
		9351
	],
	"./components/Account/ReportSearch.js": [
		21028,
		9,
		9351
	],
	"./components/Account/SuccessfullySaved": [
		10158,
		9,
		9351
	],
	"./components/Account/SuccessfullySaved.js": [
		10158,
		9,
		9351
	],
	"./components/Analyst/AnalystCard": [
		99899,
		9,
		9351
	],
	"./components/Analyst/AnalystCard.js": [
		99899,
		9,
		9351
	],
	"./components/Analyst/AnalystPage": [
		7201,
		9,
		8379,
		9351
	],
	"./components/Analyst/AnalystPage.js": [
		7201,
		9,
		8379,
		9351
	],
	"./components/Analyst/FoldOutText": [
		72633,
		9,
		9351
	],
	"./components/Analyst/FoldOutText.js": [
		72633,
		9,
		9351
	],
	"./components/AspectWrapper": [
		83655,
		9,
		9351
	],
	"./components/AspectWrapper.js": [
		83655,
		9,
		9351
	],
	"./components/BackgroundImage": [
		51811,
		9,
		1917
	],
	"./components/BackgroundImage.js": [
		51811,
		9,
		1917
	],
	"./components/Breadcrumbs": [
		64793,
		9,
		9351
	],
	"./components/Breadcrumbs/": [
		64793,
		9,
		9351
	],
	"./components/Breadcrumbs/index": [
		64793,
		9,
		9351
	],
	"./components/Breadcrumbs/index.js": [
		64793,
		9,
		9351
	],
	"./components/Breakpoints": [
		34227,
		9
	],
	"./components/Breakpoints/": [
		34227,
		9
	],
	"./components/Breakpoints/breakpointValues": [
		3506,
		9
	],
	"./components/Breakpoints/breakpointValues.js": [
		3506,
		9
	],
	"./components/Breakpoints/breakpoints": [
		35010,
		9,
		9589
	],
	"./components/Breakpoints/breakpoints.js": [
		35010,
		9,
		9589
	],
	"./components/Breakpoints/index": [
		34227,
		9
	],
	"./components/Breakpoints/index.js": [
		34227,
		9
	],
	"./components/Button": [
		7004,
		9
	],
	"./components/Button.js": [
		7004,
		9
	],
	"./components/Cart/ProductListingHeading": [
		76006,
		9
	],
	"./components/Cart/ProductListingHeading.js": [
		76006,
		9
	],
	"./components/Category/CategoryHeading": [
		48501,
		9,
		9351
	],
	"./components/Category/CategoryHeading.js": [
		48501,
		9,
		9351
	],
	"./components/Category/EmptyProductCard": [
		12890,
		9,
		9351
	],
	"./components/Category/EmptyProductCard.js": [
		12890,
		9,
		9351
	],
	"./components/Checkout/Account": [
		50943,
		9,
		9351
	],
	"./components/Checkout/Account.js": [
		50943,
		9,
		9351
	],
	"./components/Checkout/AccountLogin": [
		34303,
		9,
		9351,
		3383
	],
	"./components/Checkout/AccountLogin.js": [
		34303,
		9,
		9351,
		3383
	],
	"./components/Checkout/AccountRegister": [
		81332,
		9,
		8273,
		9351
	],
	"./components/Checkout/AccountRegister.js": [
		81332,
		9,
		8273,
		9351
	],
	"./components/Checkout/BillingDetails": [
		92885,
		9,
		668,
		9351
	],
	"./components/Checkout/BillingDetails.js": [
		92885,
		9,
		668,
		9351
	],
	"./components/Checkout/Cart": [
		99239,
		9,
		9351
	],
	"./components/Checkout/Cart.js": [
		99239,
		9,
		9351
	],
	"./components/Checkout/LoginOrRegister": [
		88595,
		9,
		6073
	],
	"./components/Checkout/LoginOrRegister.js": [
		88595,
		9,
		6073
	],
	"./components/Checkout/PaymentMethod": [
		9573,
		9,
		9351
	],
	"./components/Checkout/PaymentMethod.js": [
		9573,
		9,
		9351
	],
	"./components/Checkout/Summary": [
		44970,
		9,
		9351
	],
	"./components/Checkout/Summary.js": [
		44970,
		9,
		9351
	],
	"./components/Checkout/data/countries": [
		49978,
		9,
		9351
	],
	"./components/Checkout/data/countries.js": [
		49978,
		9,
		9351
	],
	"./components/CookieConsent": [
		29420,
		9
	],
	"./components/CookieConsent/": [
		29420,
		9
	],
	"./components/CookieConsent/config": [
		79423,
		9
	],
	"./components/CookieConsent/config.js": [
		79423,
		9
	],
	"./components/CookieConsent/cookieconsent-overrides.css": [
		23722,
		9,
		537
	],
	"./components/CookieConsent/index": [
		29420,
		9
	],
	"./components/CookieConsent/index.js": [
		29420,
		9
	],
	"./components/ErrorCatcher": [
		62446,
		9,
		9351
	],
	"./components/ErrorCatcher.js": [
		62446,
		9,
		9351
	],
	"./components/Footer": [
		8638,
		9
	],
	"./components/Footer/": [
		8638,
		9
	],
	"./components/Footer/FooterSection": [
		17261,
		9
	],
	"./components/Footer/FooterSection.js": [
		17261,
		9
	],
	"./components/Footer/Newsletter": [
		5092,
		9
	],
	"./components/Footer/Newsletter.js": [
		5092,
		9
	],
	"./components/Footer/index": [
		8638,
		9
	],
	"./components/Footer/index.js": [
		8638,
		9
	],
	"./components/Grid": [
		54329,
		9,
		9351
	],
	"./components/Grid.js": [
		54329,
		9,
		9351
	],
	"./components/Header": [
		34469,
		9
	],
	"./components/Header/": [
		34469,
		9
	],
	"./components/Header/CartPopup": [
		27335,
		9
	],
	"./components/Header/CartPopup.js": [
		27335,
		9
	],
	"./components/Header/CartPopup/CartProductCard": [
		50848,
		9
	],
	"./components/Header/CartPopup/CartProductCard.js": [
		50848,
		9
	],
	"./components/Header/CartPopup/CartProductVariation": [
		17650,
		9,
		7818
	],
	"./components/Header/CartPopup/CartProductVariation.js": [
		17650,
		9,
		7818
	],
	"./components/Header/CartPopup/RemoveFromCartButton": [
		69062,
		9
	],
	"./components/Header/CartPopup/RemoveFromCartButton.js": [
		69062,
		9
	],
	"./components/Header/CheckoutHeader": [
		59279,
		9,
		9351
	],
	"./components/Header/CheckoutHeader.js": [
		59279,
		9,
		9351
	],
	"./components/Header/HeaderCart": [
		40611,
		9
	],
	"./components/Header/HeaderCart.js": [
		40611,
		9
	],
	"./components/Header/Navigation": [
		57823,
		9
	],
	"./components/Header/Navigation/": [
		57823,
		9
	],
	"./components/Header/Navigation/HeaderLink": [
		16708,
		9
	],
	"./components/Header/Navigation/HeaderLink.js": [
		16708,
		9
	],
	"./components/Header/Navigation/index": [
		57823,
		9
	],
	"./components/Header/Navigation/index.js": [
		57823,
		9
	],
	"./components/Header/index": [
		34469,
		9
	],
	"./components/Header/index.js": [
		34469,
		9
	],
	"./components/Heading": [
		46247,
		9
	],
	"./components/Heading.js": [
		46247,
		9
	],
	"./components/Hero/Hero404": [
		42286,
		9,
		9351
	],
	"./components/Hero/Hero404.js": [
		42286,
		9,
		9351
	],
	"./components/Hero/HeroAccount": [
		42065,
		9,
		2199
	],
	"./components/Hero/HeroAccount.js": [
		42065,
		9,
		2199
	],
	"./components/Hero/HeroModuleAbout": [
		29805,
		9,
		7887
	],
	"./components/Hero/HeroModuleAbout.js": [
		29805,
		9,
		7887
	],
	"./components/Hero/HeroModuleImage": [
		11970,
		9,
		9351,
		7003
	],
	"./components/Hero/HeroModuleImage.js": [
		11970,
		9,
		9351,
		7003
	],
	"./components/Hero/HeroModuleProduct": [
		72788,
		9,
		4264
	],
	"./components/Hero/HeroModuleProduct.js": [
		72788,
		9,
		4264
	],
	"./components/Hero/HeroModuleText": [
		91226,
		9,
		8087
	],
	"./components/Hero/HeroModuleText.js": [
		91226,
		9,
		8087
	],
	"./components/Hero/HeroThankYou": [
		50597,
		9,
		9351
	],
	"./components/Hero/HeroThankYou.js": [
		50597,
		9,
		9351
	],
	"./components/Image": [
		12802,
		9
	],
	"./components/Image.js": [
		12802,
		9
	],
	"./components/Link": [
		71811,
		9
	],
	"./components/Link/": [
		71811,
		9
	],
	"./components/Link/ArrowLink": [
		86321,
		9,
		9351
	],
	"./components/Link/ArrowLink.js": [
		86321,
		9,
		9351
	],
	"./components/Link/index": [
		71811,
		9
	],
	"./components/Link/index.js": [
		71811,
		9
	],
	"./components/LoadingIndicator": [
		59590,
		9
	],
	"./components/LoadingIndicator.js": [
		59590,
		9
	],
	"./components/ModuleHeader": [
		16128,
		9,
		9351
	],
	"./components/ModuleHeader.js": [
		16128,
		9,
		9351
	],
	"./components/News/NewsPostCard": [
		64182,
		9,
		9351
	],
	"./components/News/NewsPostCard.js": [
		64182,
		9,
		9351
	],
	"./components/Pagination": [
		3957,
		9,
		9351
	],
	"./components/Pagination.js": [
		3957,
		9,
		9351
	],
	"./components/ProductCard": [
		41897,
		9,
		8379,
		9351
	],
	"./components/ProductCard.js": [
		41897,
		9,
		8379,
		9351
	],
	"./components/ProductVariationsPicker": [
		41357,
		9,
		9351
	],
	"./components/ProductVariationsPicker.js": [
		41357,
		9,
		9351
	],
	"./components/Search": [
		44741,
		9
	],
	"./components/Search/": [
		44741,
		9
	],
	"./components/Search/Context/Search": [
		38202,
		9
	],
	"./components/Search/Context/Search.js": [
		38202,
		9
	],
	"./components/Search/HiddenSearchBox": [
		76658,
		9,
		9351
	],
	"./components/Search/HiddenSearchBox.js": [
		76658,
		9,
		9351
	],
	"./components/Search/SearchCategorySuggestions": [
		49900,
		9
	],
	"./components/Search/SearchCategorySuggestions.js": [
		49900,
		9
	],
	"./components/Search/SearchIndices": [
		88107,
		9
	],
	"./components/Search/SearchIndices.js": [
		88107,
		9
	],
	"./components/Search/SearchInfoText": [
		12438,
		9
	],
	"./components/Search/SearchInfoText.js": [
		12438,
		9
	],
	"./components/Search/SearchProductCard": [
		33366,
		9
	],
	"./components/Search/SearchProductCard.js": [
		33366,
		9
	],
	"./components/Search/SearchResult": [
		89821,
		9
	],
	"./components/Search/SearchResult.js": [
		89821,
		9
	],
	"./components/Search/SearchResultHeader": [
		73485,
		9
	],
	"./components/Search/SearchResultHeader.js": [
		73485,
		9
	],
	"./components/Search/index": [
		44741,
		9
	],
	"./components/Search/index.js": [
		44741,
		9
	],
	"./components/Seo": [
		87174,
		9
	],
	"./components/Seo/": [
		87174,
		9
	],
	"./components/Seo/index": [
		87174,
		9
	],
	"./components/Seo/index.js": [
		87174,
		9
	],
	"./components/Templates/404": [
		80553,
		9,
		9351,
		7701
	],
	"./components/Templates/404.js": [
		80553,
		9,
		9351,
		7701
	],
	"./components/Text": [
		62497,
		9
	],
	"./components/Text.js": [
		62497,
		9
	],
	"./components/ToggableText": [
		93250,
		9,
		9351
	],
	"./components/ToggableText.js": [
		93250,
		9,
		9351
	],
	"./components/Video/Video": [
		77682,
		9,
		9351
	],
	"./components/Video/Video.js": [
		77682,
		9,
		9351
	],
	"./components/WysiwygWrapper": [
		96946,
		9
	],
	"./components/WysiwygWrapper/": [
		96946,
		9
	],
	"./components/WysiwygWrapper/BlockQuote": [
		29618,
		9
	],
	"./components/WysiwygWrapper/BlockQuote.js": [
		29618,
		9
	],
	"./components/WysiwygWrapper/Bold": [
		46283,
		9
	],
	"./components/WysiwygWrapper/Bold.js": [
		46283,
		9
	],
	"./components/WysiwygWrapper/HeadingLevelFour": [
		72436,
		9
	],
	"./components/WysiwygWrapper/HeadingLevelFour.js": [
		72436,
		9
	],
	"./components/WysiwygWrapper/HeadingLevelThree": [
		49431,
		9
	],
	"./components/WysiwygWrapper/HeadingLevelThree.js": [
		49431,
		9
	],
	"./components/WysiwygWrapper/Italic": [
		80429,
		9
	],
	"./components/WysiwygWrapper/Italic.js": [
		80429,
		9
	],
	"./components/WysiwygWrapper/ListItem": [
		49385,
		9
	],
	"./components/WysiwygWrapper/ListItem.js": [
		49385,
		9
	],
	"./components/WysiwygWrapper/OrderedList": [
		72004,
		9
	],
	"./components/WysiwygWrapper/OrderedList.js": [
		72004,
		9
	],
	"./components/WysiwygWrapper/Underline": [
		5475,
		9
	],
	"./components/WysiwygWrapper/Underline.js": [
		5475,
		9
	],
	"./components/WysiwygWrapper/UnorderedList": [
		13459,
		9
	],
	"./components/WysiwygWrapper/UnorderedList.js": [
		13459,
		9
	],
	"./components/WysiwygWrapper/UnorderedListItem": [
		49728,
		9
	],
	"./components/WysiwygWrapper/UnorderedListItem.js": [
		49728,
		9
	],
	"./components/WysiwygWrapper/Url": [
		32013,
		9
	],
	"./components/WysiwygWrapper/Url.js": [
		32013,
		9
	],
	"./components/WysiwygWrapper/index": [
		96946,
		9
	],
	"./components/WysiwygWrapper/index.js": [
		96946,
		9
	],
	"./components/auth/Forgot": [
		50323,
		9,
		9351
	],
	"./components/auth/Forgot.js": [
		50323,
		9,
		9351
	],
	"./components/auth/Login": [
		28983,
		9,
		3616,
		4094,
		9351
	],
	"./components/auth/Login.js": [
		28983,
		9,
		3616,
		4094,
		9351
	],
	"./components/auth/Register": [
		41188,
		9,
		3616,
		9351
	],
	"./components/auth/Register.js": [
		41188,
		9,
		3616,
		9351
	],
	"./components/auth/Reset": [
		8732,
		9,
		9351
	],
	"./components/auth/Reset.js": [
		8732,
		9,
		9351
	],
	"./components/buttons/AddToCartButton": [
		61626,
		9,
		9351
	],
	"./components/buttons/AddToCartButton.js": [
		61626,
		9,
		9351
	],
	"./components/buttons/BurgerButton": [
		46792,
		9
	],
	"./components/buttons/BurgerButton.js": [
		46792,
		9
	],
	"./components/buttons/CheckboxButton": [
		34989,
		9
	],
	"./components/buttons/CheckboxButton.js": [
		34989,
		9
	],
	"./components/buttons/CrossButton": [
		14791,
		9
	],
	"./components/buttons/CrossButton.js": [
		14791,
		9
	],
	"./components/buttons/DownloadReportButton": [
		71874,
		9,
		9351
	],
	"./components/buttons/DownloadReportButton.js": [
		71874,
		9,
		9351
	],
	"./components/buttons/PlusMinusButton": [
		48311,
		9
	],
	"./components/buttons/PlusMinusButton.js": [
		48311,
		9
	],
	"./components/buttons/ProductCardButton": [
		92784,
		9
	],
	"./components/buttons/ProductCardButton.js": [
		92784,
		9
	],
	"./components/buttons/RadioButton": [
		89076,
		9,
		9351
	],
	"./components/buttons/RadioButton.js": [
		89076,
		9,
		9351
	],
	"./components/form/Input": [
		11067,
		9
	],
	"./components/form/Input.js": [
		11067,
		9
	],
	"./components/form/Select": [
		49853,
		9,
		9351
	],
	"./components/form/Select.js": [
		49853,
		9,
		9351
	],
	"./components/general/Error": [
		68543,
		9,
		9351
	],
	"./components/general/Error.js": [
		68543,
		9,
		9351
	],
	"./components/global/mediaqueries": [
		70115,
		9
	],
	"./components/global/mediaqueries.js": [
		70115,
		9
	],
	"./components/layout": [
		37198,
		9
	],
	"./components/layout.js": [
		37198,
		9
	],
	"./components/pages/SearchResultsPage": [
		92705,
		9,
		8379,
		8093,
		9351
	],
	"./components/pages/SearchResultsPage.js": [
		92705,
		9,
		8379,
		8093,
		9351
	],
	"./components/pages/account": [
		95013,
		9,
		2904,
		6294,
		9351,
		5696
	],
	"./components/pages/account.js": [
		95013,
		9,
		2904,
		6294,
		9351,
		5696
	],
	"./components/pages/forgot-password": [
		79181,
		9,
		9351,
		4357
	],
	"./components/pages/forgot-password.js": [
		79181,
		9,
		9351,
		4357
	],
	"./components/pages/login": [
		38015,
		9,
		3616,
		4094,
		9351,
		4303
	],
	"./components/pages/login.js": [
		38015,
		9,
		3616,
		4094,
		9351,
		4303
	],
	"./components/pages/register": [
		93550,
		9,
		3616,
		9351,
		4421
	],
	"./components/pages/register.js": [
		93550,
		9,
		3616,
		9351,
		4421
	],
	"./components/pages/reset-password": [
		87545,
		9,
		9351,
		7514
	],
	"./components/pages/reset-password.js": [
		87545,
		9,
		9351,
		7514
	],
	"./components/post/BigPostCard": [
		54365,
		9,
		9351
	],
	"./components/post/BigPostCard.js": [
		54365,
		9,
		9351
	],
	"./components/post/BigPostText": [
		75753,
		9,
		9351
	],
	"./components/post/BigPostText.js": [
		75753,
		9,
		9351
	],
	"./components/post/PostCard": [
		24480,
		9,
		9351
	],
	"./components/post/PostCard.js": [
		24480,
		9,
		9351
	],
	"./components/product/formatProductDate": [
		32875,
		9,
		9351
	],
	"./components/product/formatProductDate.js": [
		32875,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightList": [
		91433,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightList.js": [
		91433,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightSection": [
		49628,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightSection.js": [
		49628,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightText": [
		53076,
		9,
		9351
	],
	"./components/product/highlight/ProductHighlightText.js": [
		53076,
		9,
		9351
	],
	"./components/productGallery/Interactable": [
		8306,
		9,
		9351
	],
	"./components/productGallery/Interactable.js": [
		8306,
		9,
		9351
	],
	"./components/productGallery/ProductGallery": [
		10410,
		9,
		9351
	],
	"./components/productGallery/ProductGallery.js": [
		10410,
		9,
		9351
	],
	"./components/productGallery/ProductGalleryButton": [
		55493,
		9,
		9351
	],
	"./components/productGallery/ProductGalleryButton.js": [
		55493,
		9,
		9351
	],
	"./components/productInfo/ProductInfo": [
		41960,
		9,
		9351
	],
	"./components/productInfo/ProductInfo.js": [
		41960,
		9,
		9351
	],
	"./components/productInfo/ProductInfoPopup": [
		41664,
		9,
		9351
	],
	"./components/productInfo/ProductInfoPopup.js": [
		41664,
		9,
		9351
	],
	"./components/productInfo/ProductInfoTableOfContents": [
		84630,
		9,
		9351
	],
	"./components/productInfo/ProductInfoTableOfContents.js": [
		84630,
		9,
		9351
	],
	"./components/tracking/DataLayer": [
		80860,
		9
	],
	"./components/tracking/DataLayer.js": [
		80860,
		9
	],
	"./components/typography/Tag": [
		66936,
		9
	],
	"./components/typography/Tag.js": [
		66936,
		9
	],
	"./components/typography/TextNumber": [
		38802,
		9,
		9351
	],
	"./components/typography/TextNumber.js": [
		38802,
		9,
		9351
	],
	"./components/user/AccountDetails": [
		15024,
		9,
		3899
	],
	"./components/user/AccountDetails.js": [
		15024,
		9,
		3899
	],
	"./components/user/ReportList": [
		22062,
		9,
		2981
	],
	"./components/user/ReportList.js": [
		22062,
		9,
		2981
	],
	"./components/utils/AuthRoute": [
		12335,
		9,
		182
	],
	"./components/utils/AuthRoute.js": [
		12335,
		9,
		182
	],
	"./components/utils/supportsPassiveEvents": [
		89067,
		9,
		9351
	],
	"./components/utils/supportsPassiveEvents.js": [
		89067,
		9,
		9351
	],
	"./containers/WysiwygContainer": [
		28001,
		9
	],
	"./containers/WysiwygContainer.js": [
		28001,
		9
	],
	"./helpers/auth-header": [
		72881,
		9,
		4093
	],
	"./helpers/auth-header.js": [
		72881,
		9,
		4093
	],
	"./hooks/useAuth": [
		10352,
		9
	],
	"./hooks/useAuth.js": [
		10352,
		9
	],
	"./hooks/useProductCategories": [
		56793,
		9,
		9351
	],
	"./hooks/useProductCategories.js": [
		56793,
		9,
		9351
	],
	"./hooks/useProductPanel": [
		95077,
		9,
		9351
	],
	"./hooks/useProductPanel.js": [
		95077,
		9,
		9351
	],
	"./hooks/useProductPermalinkLookup": [
		71844,
		9,
		9351
	],
	"./hooks/useProductPermalinkLookup.js": [
		71844,
		9,
		9351
	],
	"./hooks/useReportSearchIds": [
		31567,
		9,
		9351
	],
	"./hooks/useReportSearchIds.js": [
		31567,
		9,
		9351
	],
	"./html": [
		90230,
		9,
		4787
	],
	"./html.js": [
		90230,
		9,
		4787
	],
	"./icons/Arrow": [
		63936,
		9
	],
	"./icons/Arrow.js": [
		63936,
		9
	],
	"./icons/BergStar": [
		68490,
		9
	],
	"./icons/BergStar.js": [
		68490,
		9
	],
	"./icons/Download": [
		7638,
		9,
		9351
	],
	"./icons/Download.js": [
		7638,
		9,
		9351
	],
	"./icons/LinkedIn": [
		82096,
		9,
		9351
	],
	"./icons/LinkedIn.js": [
		82096,
		9,
		9351
	],
	"./icons/MyPageIcon": [
		34935,
		9
	],
	"./icons/MyPageIcon.js": [
		34935,
		9
	],
	"./icons/SearchIcon": [
		79822,
		9
	],
	"./icons/SearchIcon.js": [
		79822,
		9
	],
	"./icons/Spinner": [
		49597,
		9
	],
	"./icons/Spinner.js": [
		49597,
		9
	],
	"./icons/base/Circle": [
		87856,
		9
	],
	"./icons/base/Circle.js": [
		87856,
		9
	],
	"./icons/base/Group": [
		54664,
		9,
		4919
	],
	"./icons/base/Group.js": [
		54664,
		9,
		4919
	],
	"./icons/base/Line": [
		5020,
		9
	],
	"./icons/base/Line.js": [
		5020,
		9
	],
	"./icons/base/Path": [
		60092,
		9
	],
	"./icons/base/Path.js": [
		60092,
		9
	],
	"./icons/base/SVG": [
		56502,
		9
	],
	"./icons/base/SVG.js": [
		56502,
		9
	],
	"./icons/leftCursor.svg": [
		63733,
		9,
		9351
	],
	"./icons/rightCursor.svg": [
		86517,
		9,
		9351
	],
	"./images/404.jpg": [
		51331,
		9,
		4055
	],
	"./images/ThankYou.jpg": [
		65338,
		9,
		1763
	],
	"./images/gatsby-astronaut.png": [
		19697,
		9,
		4980
	],
	"./images/gatsby-icon.png": [
		54396,
		9,
		7261
	],
	"./images/login-background.jpg": [
		81729,
		9,
		7454
	],
	"./libs/BergCommerceAPI/Basket/AddToCart": [
		98039,
		9,
		9351
	],
	"./libs/BergCommerceAPI/Basket/AddToCart.js": [
		98039,
		9,
		9351
	],
	"./libs/BergCommerceAPI/Basket/Context/Cart": [
		56981,
		9
	],
	"./libs/BergCommerceAPI/Basket/Context/Cart.js": [
		56981,
		9
	],
	"./libs/BergCommerceAPI/Basket/Cookies": [
		46105,
		9
	],
	"./libs/BergCommerceAPI/Basket/Cookies.js": [
		46105,
		9
	],
	"./libs/BergCommerceAPI/Basket/GenerateBasketKey": [
		29559,
		9
	],
	"./libs/BergCommerceAPI/Basket/GenerateBasketKey.js": [
		29559,
		9
	],
	"./libs/BergCommerceAPI/Basket/GetBasket": [
		92159,
		9
	],
	"./libs/BergCommerceAPI/Basket/GetBasket.js": [
		92159,
		9
	],
	"./libs/BergCommerceAPI/Basket/ItemCount": [
		31194,
		9
	],
	"./libs/BergCommerceAPI/Basket/ItemCount.js": [
		31194,
		9
	],
	"./libs/BergCommerceAPI/Basket/RemoveFromCart": [
		75186,
		9
	],
	"./libs/BergCommerceAPI/Basket/RemoveFromCart.js": [
		75186,
		9
	],
	"./libs/BergCommerceAPI/Basket/getCheckoutHref": [
		53589,
		9,
		17
	],
	"./libs/BergCommerceAPI/Basket/getCheckoutHref.js": [
		53589,
		9,
		17
	],
	"./libs/BergCommerceAPI/util": [
		5869,
		9,
		4995
	],
	"./libs/BergCommerceAPI/util/": [
		5869,
		9,
		4995
	],
	"./libs/BergCommerceAPI/util/buildQueryString": [
		90024,
		9
	],
	"./libs/BergCommerceAPI/util/buildQueryString.js": [
		90024,
		9
	],
	"./libs/BergCommerceAPI/util/fetch": [
		14302,
		9
	],
	"./libs/BergCommerceAPI/util/fetch.js": [
		14302,
		9
	],
	"./libs/BergCommerceAPI/util/fetch.spec": [
		8893,
		9,
		4386
	],
	"./libs/BergCommerceAPI/util/fetch.spec.js": [
		8893,
		9,
		4386
	],
	"./libs/BergCommerceAPI/util/index": [
		5869,
		9,
		4995
	],
	"./libs/BergCommerceAPI/util/index.js": [
		5869,
		9,
		4995
	],
	"./libs/scroll": [
		30814,
		9
	],
	"./libs/scroll.js": [
		30814,
		9
	],
	"./load-module": [
		84345,
		9
	],
	"./load-module.js": [
		84345,
		9
	],
	"./modules/Analysts": [
		35998,
		9,
		9351,
		2745
	],
	"./modules/Analysts/": [
		35998,
		9,
		9351,
		2745
	],
	"./modules/Analysts/index": [
		35998,
		9,
		9351,
		2745
	],
	"./modules/Analysts/index.js": [
		35998,
		9,
		9351,
		2745
	],
	"./modules/Content": [
		56293,
		9,
		9351,
		6357
	],
	"./modules/Content/": [
		56293,
		9,
		9351,
		6357
	],
	"./modules/Content/index": [
		56293,
		9,
		9351,
		6357
	],
	"./modules/Content/index.js": [
		56293,
		9,
		9351,
		6357
	],
	"./modules/Faq": [
		12691,
		9,
		9351,
		6153
	],
	"./modules/Faq/": [
		12691,
		9,
		9351,
		6153
	],
	"./modules/Faq/FaqItem": [
		88146,
		9,
		9351
	],
	"./modules/Faq/FaqItem.js": [
		88146,
		9,
		9351
	],
	"./modules/Faq/index": [
		12691,
		9,
		9351,
		6153
	],
	"./modules/Faq/index.js": [
		12691,
		9,
		9351,
		6153
	],
	"./modules/Header/Article": [
		95310,
		9,
		9351,
		7472
	],
	"./modules/Header/Article.js": [
		95310,
		9,
		9351,
		7472
	],
	"./modules/Header/ArticleText": [
		78659,
		9,
		9351
	],
	"./modules/Header/ArticleText.js": [
		78659,
		9,
		9351
	],
	"./modules/Header/LinksReport": [
		45716,
		9,
		9351,
		3153
	],
	"./modules/Header/LinksReport.js": [
		45716,
		9,
		9351,
		3153
	],
	"./modules/Header/VerticalHeading": [
		38598,
		9,
		9351
	],
	"./modules/Header/VerticalHeading.js": [
		38598,
		9,
		9351
	],
	"./modules/Link": [
		12948,
		9,
		7358
	],
	"./modules/Link/": [
		12948,
		9,
		7358
	],
	"./modules/Link/index": [
		12948,
		9,
		7358
	],
	"./modules/Link/index.js": [
		12948,
		9,
		7358
	],
	"./modules/NewsListing": [
		48512,
		9,
		4660,
		9351
	],
	"./modules/NewsListing/": [
		48512,
		9,
		4660,
		9351
	],
	"./modules/NewsListing/index": [
		48512,
		9,
		4660,
		9351
	],
	"./modules/NewsListing/index.js": [
		48512,
		9,
		4660,
		9351
	],
	"./modules/NotFound": [
		81932,
		9
	],
	"./modules/NotFound/": [
		81932,
		9
	],
	"./modules/NotFound/index": [
		81932,
		9
	],
	"./modules/NotFound/index.js": [
		81932,
		9
	],
	"./modules/OneSectionPosts": [
		53891,
		9,
		9351
	],
	"./modules/OneSectionPosts/": [
		53891,
		9,
		9351
	],
	"./modules/OneSectionPosts/index": [
		53891,
		9,
		9351
	],
	"./modules/OneSectionPosts/index.js": [
		53891,
		9,
		9351
	],
	"./modules/PostModules/ImageSection": [
		85739,
		9,
		6212
	],
	"./modules/PostModules/ImageSection.js": [
		85739,
		9,
		6212
	],
	"./modules/PostModules/TextSection": [
		82227,
		9,
		3749
	],
	"./modules/PostModules/TextSection.js": [
		82227,
		9,
		3749
	],
	"./modules/Posts": [
		41047,
		9,
		9351,
		5835
	],
	"./modules/Posts/": [
		41047,
		9,
		9351,
		5835
	],
	"./modules/Posts/index": [
		41047,
		9,
		9351,
		5835
	],
	"./modules/Posts/index.js": [
		41047,
		9,
		9351,
		5835
	],
	"./modules/Products": [
		6754,
		9,
		8379,
		9351
	],
	"./modules/Products/": [
		6754,
		9,
		8379,
		9351
	],
	"./modules/Products/index": [
		6754,
		9,
		8379,
		9351
	],
	"./modules/Products/index.js": [
		6754,
		9,
		8379,
		9351
	],
	"./modules/Quote": [
		23939,
		9,
		9351,
		3973
	],
	"./modules/Quote/": [
		23939,
		9,
		9351,
		3973
	],
	"./modules/Quote/index": [
		23939,
		9,
		9351,
		3973
	],
	"./modules/Quote/index.js": [
		23939,
		9,
		9351,
		3973
	],
	"./modules/Reference": [
		4450,
		9,
		9351,
		7392
	],
	"./modules/Reference/": [
		4450,
		9,
		9351,
		7392
	],
	"./modules/Reference/index": [
		4450,
		9,
		9351,
		7392
	],
	"./modules/Reference/index.js": [
		4450,
		9,
		9351,
		7392
	],
	"./modules/References": [
		13602,
		9,
		9351,
		9602
	],
	"./modules/References/": [
		13602,
		9,
		9351,
		9602
	],
	"./modules/References/index": [
		13602,
		9,
		9351,
		9602
	],
	"./modules/References/index.js": [
		13602,
		9,
		9351,
		9602
	],
	"./modules/SinglePost": [
		67850,
		9,
		9351
	],
	"./modules/SinglePost/": [
		67850,
		9,
		9351
	],
	"./modules/SinglePost/index": [
		67850,
		9,
		9351
	],
	"./modules/SinglePost/index.js": [
		67850,
		9,
		9351
	],
	"./modules/SingleProduct": [
		42453,
		9,
		8367,
		9351
	],
	"./modules/SingleProduct/": [
		42453,
		9,
		8367,
		9351
	],
	"./modules/SingleProduct/index": [
		42453,
		9,
		8367,
		9351
	],
	"./modules/SingleProduct/index.js": [
		42453,
		9,
		8367,
		9351
	],
	"./modules/Text": [
		72303,
		9,
		9351
	],
	"./modules/Text/": [
		72303,
		9,
		9351
	],
	"./modules/Text/index": [
		72303,
		9,
		9351
	],
	"./modules/Text/index.js": [
		72303,
		9,
		9351
	],
	"./modules/TextImage": [
		59261,
		9,
		3997
	],
	"./modules/TextImage/": [
		59261,
		9,
		3997
	],
	"./modules/TextImage/index": [
		59261,
		9,
		3997
	],
	"./modules/TextImage/index.js": [
		59261,
		9,
		3997
	],
	"./styles/main.css": [
		14348,
		9,
		7476
	],
	"./styles/theme": [
		25130,
		9
	],
	"./styles/theme.js": [
		25130,
		9
	],
	"./templates": [
		6772,
		9,
		1003
	],
	"./templates/": [
		6772,
		9,
		1003
	],
	"./templates/MainTemplate": [
		13871,
		9
	],
	"./templates/MainTemplate.js": [
		13871,
		9
	],
	"./templates/ThankYou": [
		40616,
		9,
		9351,
		4253
	],
	"./templates/ThankYou.js": [
		40616,
		9,
		9351,
		4253
	],
	"./templates/analyst": [
		92551,
		9,
		8379,
		9351,
		3763
	],
	"./templates/analyst.js": [
		92551,
		9,
		8379,
		9351,
		3763
	],
	"./templates/category": [
		24098,
		9,
		8379,
		5839,
		9351,
		5924
	],
	"./templates/category.js": [
		24098,
		9,
		8379,
		5839,
		9351,
		5924
	],
	"./templates/checkout": [
		20141,
		9,
		668,
		4704,
		9351
	],
	"./templates/checkout.js": [
		20141,
		9,
		668,
		4704,
		9351
	],
	"./templates/index": [
		6772,
		9,
		1003
	],
	"./templates/index.js": [
		6772,
		9,
		1003
	],
	"./templates/page": [
		74755,
		9,
		9351,
		2510
	],
	"./templates/page.js": [
		74755,
		9,
		9351,
		2510
	],
	"./templates/post": [
		19857,
		9,
		6118,
		9351
	],
	"./templates/post.js": [
		19857,
		9,
		6118,
		9351
	],
	"./templates/product": [
		90111,
		9,
		7954,
		9351
	],
	"./templates/product.js": [
		90111,
		9,
		7954,
		9351
	],
	"./utils/algolia-queries": [
		18073,
		7,
		9351,
		9436
	],
	"./utils/algolia-queries.js": [
		18073,
		7,
		9351,
		9436
	],
	"./utils/checkRequiredFields": [
		3442,
		9,
		9351
	],
	"./utils/checkRequiredFields.js": [
		3442,
		9,
		9351
	],
	"./utils/dynamicScaling": [
		10692,
		9
	],
	"./utils/dynamicScaling.js": [
		10692,
		9
	],
	"./utils/formatDate": [
		36854,
		9
	],
	"./utils/formatDate.js": [
		36854,
		9
	],
	"./utils/formatPrice": [
		26244,
		9
	],
	"./utils/formatPrice.js": [
		26244,
		9
	],
	"./utils/getToken": [
		5001,
		9,
		9351
	],
	"./utils/getToken.js": [
		5001,
		9,
		9351
	],
	"./utils/getUserData": [
		85701,
		9,
		9351
	],
	"./utils/getUserData.js": [
		85701,
		9,
		9351
	],
	"./utils/getWindowSize": [
		61160,
		9,
		9351
	],
	"./utils/getWindowSize.js": [
		61160,
		9,
		9351
	],
	"./utils/htmlDecode": [
		23362,
		9
	],
	"./utils/htmlDecode.js": [
		23362,
		9
	],
	"./utils/inBrowser": [
		35948,
		9
	],
	"./utils/inBrowser.js": [
		35948,
		9
	],
	"./utils/isLoggedIn": [
		35230,
		9
	],
	"./utils/isLoggedIn.js": [
		35230,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 19506;
module.exports = webpackAsyncContext;